module.exports = __webpack_public_path__ + "static/media/scanner.2490ea08.svg";